import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-payment-panel-adyen-meal-voucher-natixis',
  templateUrl: './payment-panel-adyen-meal-voucher-natixis.component.html',
  standalone: false,
})
export class PaymentPanelAdyenMealVoucherNatixisComponent {
  @Input() clientKey?: string;
  @Input() useTestApi?: boolean;
  @Input() paymentMethodMealVoucherNatixisAvailable = false;
}
